import React, { FC, ReactElement, useEffect } from "react";
import { useIntercom } from "react-use-intercom";

import { StyledDrawer, TopContent } from "./Drawer.styled";

import { Stack, Typography } from "@components/base";

interface Drawer {
  open: boolean;
  onClose: () => void;
  title?: string;
  content: ReactElement;
  noPadding?: boolean;
}

const Drawer: FC<Drawer> = ({
  open = false,
  onClose,
  title,
  content,
  noPadding,
}) => {
  const { shutdown, boot } = useIntercom();

  useEffect(() => {
    if (open) {
      shutdown();
    } else {
      boot();
    }
  }, [open]);

  return (
    <StyledDrawer
      anchor={"right"}
      open={open}
      onClose={onClose}
      sx={
        noPadding ? { [".MuiDrawer-paperAnchorRight"]: { padding: 0 } } : undefined
      }
    >
      {title && (
        <TopContent>
          <Typography variant="h5">{title}</Typography>
        </TopContent>
      )}
      <Stack flex={1}>{content}</Stack>
    </StyledDrawer>
  );
};

export default Drawer;
